import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Tool_printIcon from "../../Components/Tools/Tool_printIcon";
import Tool_mealList from "../../Components/Tools/Tool_mealList";
import Tool_mealListShowOnly from "../../Components/Tools/Tool_mealListShowOnly";
import Tool_showExtraDataList from "../../Components/Tools/Tool_showExtraDataList";
// import Tool_printOrder from '../../Components/Tools/Tool_printOrder';
import { Global } from "../../App";
import {
  AsyncModel,
  AsyncModelClose,
} from "../../Components/AsyncModel/AsyncModel";
import ReactLoading from "react-loading";
import { FormattedMessage } from "react-intl";
import { CusButton } from "../../Components/From/Button";
import { CusCheckbox } from "../../Components/From/Checkbox";
import cls from "classnames";
import "../pages.scss";

// switch lang
import { langStringToCode,langCodeToString} from "../../Share/Tools/switchLang";

// api
import {
  getOrderInfo,
  getOrderDetail,
  getOrderReprintPreOrder,
  //getOrderInfoData,
} from "../../Api/staff/GetOrderInfo";
import moment from "moment";

import ErrorPage from "../Error/Error";

import calcTotal from "../../Share/Tools/calcTotal";

function StaffOrderDetail(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    dineIn: [],
    takeout: [],
    orderInfo: null,
    isError: false,
    isCheckPrintDetail: false,
  });

  const $handleError = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isError: true,
    }));
  }, []);
  async function apiOrderInfo(orderCode, langId, waiterID, storeID, createAt) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false,
    });
    try {
      const res = await getOrderInfo(
        orderCode,
        langId,
        waiterID,
        storeID,
        createAt
      );
      //const res = await getOrderInfoData(
      //  orderCode,
      //  langId,
      //  waiterID,
      //  storeID,
      //  createAt
      //);
      const { errCode, productList } = res.data;
      AsyncModelClose();
      if (errCode == 200) {
        return productList;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        $handleError();
        // props.history.push('/staff/error');
      }
    } catch (err) {
      console.error("OrderInfo error.");

      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 413 }],
      });
      $handleError();
      // props.history.push('/staff/error');
    }
  }

  async function apiOrderDetail(orderCode, langId, storeID, createAt) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false,
    });
    try {
      const res = await getOrderDetail(orderCode, langId, storeID, createAt);
      const { errCode, productList } = res.data;
      AsyncModelClose();
      if (errCode == 200) {
        return productList;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        $handleError();
        // props.history.push('/staff/error');
      }
    } catch (err) {
      console.error("OrderDetail error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 414 }],
      });
      $handleError();
      // props.history.push('/staff/error');
    }
  }

  async function apiReprintPreOrder(posCode, orderCode, storeID) {
    const waittingAlert = AsyncModel({
      content: (
        <div className="w-100 d-flex justify-content-center">
          <ReactLoading
            type="spokes"
            color="#ccc"
            height="100px"
            width="100px"
          />
        </div>
      ),
      showConfirmBtn: false,
    });
    try {
      const res = await getOrderReprintPreOrder(posCode, orderCode, storeID);
      const { errCode, isSuccess } = res.data;
      AsyncModelClose();
      if (errCode == 200 && isSuccess) {
        console.log("Reprint OK");
        await AsyncModel({
          title: globalState.langFile["pages.staffOrderDetail.reprintSuccess"],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        $handleError();
        // props.history.push('/staff/error');
      }
    } catch (err) {
      console.error("OrderReprintPreOrder error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 414 }],
      });
      $handleError();
      // props.history.push('/staff/error');
    }
  }

  // call api
  useEffect(() => {
    const handler = async () => {
      const orderCode = globalState.staffInfo.orderCode;
      const storeID = globalState.staffInfo.checkOrderBranch.branchCode;
      const createAt = moment(globalState.staffInfo.createAt).format(
        "YYYY/MM/DD"
      );
      const { langType } = globalState;

      let orderDetail = await apiOrderDetail(
        orderCode,
        langStringToCode(langType),
        storeID,
        createAt
      );
      console.log("orderDetail", orderDetail);

      if (orderDetail) {
        let parser = {
          checkedTime: orderDetail.checkAt,
          customerInfo: {
            adult: orderDetail.adultsCount,
            branch: orderDetail.storeName,
            child: orderDetail.childCount,
            // countryName:orderDetail.countryName
          },
          diningTime: orderDetail.edtAt,
          // 未失效，且非本日單且未對單，前端顯示過期
          isOrderValid: orderDetail.alive
            ? orderDetail.status === 1 &&
              Date.parse(orderDetail.createAt) -
                Date.parse(moment(new Date()).format("YYYY/MM/DD")) <
                0
              ? 2
              : 1
            : 0,
          // isOrderValid: orderDetail.alive,
          orderCode: orderDetail.orderCode,
          orderState: orderDetail.status,
          orderTime: orderDetail.createAt,
          staffInfo: {
            group: orderDetail.groupName,
            staff: orderDetail.waiterName,
            staffCode: orderDetail.waiterWorkNum,
          },
          queueNumber: orderDetail.queue_num,
          posCode: orderDetail.posCode,
          TableNo: orderDetail.posTableNo,
          extraDataList: orderDetail.extraDataList,
          lineInTable: orderDetail.lineInTable,
          lineInTableNo: orderDetail.lineInTableNo
        };
        setState((curr) => {
          return {
            ...curr,
            dineIn: orderDetail.dineIn, //JSON.parse(a),
            takeout: orderDetail.takeout,
            orderInfo: parser,
            countryName: orderDetail.countryName,
          };
        });
      }
    };
    handler();
  }, [globalState.langType]);

  const $totalPrice = useMemo(() => {
    const { dineIn, takeout } = state;
    const takeoutTotals = calcTotal(takeout);
    const dineInTotals = calcTotal(dineIn);

    return {
      dineInTotalPrice: dineInTotals.total,
      dineInSpecPrice: dineInTotals.tasteTotal,
      takeoutInTotalPrice: takeoutTotals.total,
      takeoutInSpecPrice: takeoutTotals.tasteTotal,
    };
  }, [state]);

  const totalPrice = () => {
    return $totalPrice;
  };
  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };

  function checkIsOrderValid(data) {
    switch (data) {
      case 0:
        return {
          txt: "pages.staffOrderDetail.orderValid.invalid",
          style: "orderStateExpired",
        };
      case 1:
        return {
          txt: "pages.staffOrderDetail.orderValid.valid",
          style: "",
        };
      case 2:
        return {
          txt: "pages.staffOrderDetail.orderValid.expired",
          style: "",
        };
      default:
        throw Error(`checkIsOrderValid error ${data}`);
    }
  }
  function parserOrderState(orderState) {
    switch (orderState) {
      case 1: //1=已成立(未對單)
        return {
          txt: "pages.staffOrderDetail.orderState.uncheck",
          style: "orderStateUncheck",
        };
      case 2: //2=已對單(不可改，可取消)
        return {
          txt: "pages.staffOrderDetail.orderState.check",
          style: "orderStateChecked",
        };
      case 3: //3=未轉單
        return {
          txt: "pages.staffOrderDetail.orderState.NotTransfer",
          style: "orderStateChecked",
        };
      case 4: //4=已轉單(正式單，皆不可)
        return {
          txt: "pages.staffOrderDetail.orderState.official",
          style: "orderStateOfficial",
        };
      case 5: //5=轉單異常
        return {
          txt: "pages.staffOrderDetail.orderState.TransferError",
          style: "orderStateOfficial",
        };
      //6=對單中
      case 6: {
        return {
          txt: "pages.staffOrderDetail.orderState.checking",
          style: "orderStateChecking",
        };
      }
      case 0:
        return {
          txt: "pages.staffOrderDetail.orderState.invalid",
          style: "orderStateExpired",
        };
      default:
        throw Error(`parserOrderState error ${orderState}`);
    }
  }

  const $disabledCheckInButton = useMemo(() => {
    if (
      state.orderInfo !== null &&
      state.orderInfo.isOrderValid === 1 &&
      moment().isSame(state.orderInfo.orderTime, "D")
    ) {
      if (
        state.orderInfo.orderState === 6 &&
        state.orderInfo.staffInfo.staffCode ===
          globalState.staffInfo.checkOrderStaff.staffNum
      ) {
        return false;
      }

      if (state.orderInfo.orderState === 1) {
        return false;
      }
    }

    return true;
  }, [state, globalState]);

  const $canReprint = useMemo(() => {
    // 僅有當日已對單可列印
    if (
      state.orderInfo !== null &&
      state.orderInfo.isOrderValid === 1 &&
      moment().isSame(state.orderInfo.orderTime, "D") &&
      state.orderInfo.orderState === 2
    ) {
      return true;
    }

    return false;
  }, [state]);

  if (state.isError) {
    return <ErrorPage />;
  }

  if (!state.orderInfo) return null;
  return (
    <>
      <div className="Pages">
        <Header props={props} />
        {/* {
          !$disabledCheckInButton ? (
            <Tool_printIcon />
          ) : null
        } */}
        <div className="TakeOrder col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
          <div className="Pages__section d-flex flex-column align-items-center pb-sm-4">
            <div className="Pages__title d-flex">
              {state.orderInfo.TableNo
                ? state.orderInfo.TableNo +
                  globalState.langFile["pages.staffOrderDetail.table"]
                : ""}
              <FormattedMessage
                id="pages.staffOrderDetail.title"
                children={(e) => {
                  const { langType } = globalState;
                  if (
                    langType !== "zh" &&
                    langType !== "ja" &&
                    langType !== "ko"
                  ) {
                    const splitString = e.split(" ");
                    return splitString.map((e, index) => (
                      <div
                        key={index}
                        className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                      >
                        <div>{e}</div>
                      </div>
                    ));
                  } else {
                    const splitString = e.split("");
                    return splitString.map((e, index) => (
                      <div
                        key={index}
                        className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                      >
                        <div>{e}</div>
                      </div>
                    ));
                  }
                }}
              />
            </div>
          </div>
          <div className="Pages__space w-100 mt-3 m-sm-0">
            {
              //預點直接轉單顯示POS、ThirdParty錯誤訊息
              //$disabledCheckInButton?null:
              //<div className="Pages__space__item p-3">
                //※訂單商品異常_請重新下單;1-005-883 迷你豆沙包規格餘量不足：2-G017-003 2個-熱
              //</div>
            }            
            <div className="Pages__space__item p-3">
              {
                //預點直接轉單顯示POS、ThirdParty錯誤訊息
                //$disabledCheckInButton?null:
                //<div className="d-flex justify-content-between align-items-center pt-2 pb-2 Pages__specification__title font-weight-bold">
                  //※訂單商品異常_請重新下單;1-005-883 迷你豆沙包規格餘量不足：2-G017-003 2個-熱
                //</div>
              }
              {/* POS單號 */}
              {state.orderInfo && state.orderInfo.posCode ? (
                <div className="d-flex justify-content-between align-items-center pt-2 pb-2 Pages__specification__title font-weight-bold">
                  <div>
                    <span className="mr-2">
                      <FormattedMessage id="pages.staffOrderDetail.orderInfo.posNumber" />
                      :
                    </span>
                    <span className="mr-2">{state.orderInfo.posCode}</span>
                  </div>
                </div>
              ) : null}
              {/* 訂單代碼 */}
              <div className="d-flex justify-content-between align-items-center pt-2 pb-2">
                <div>
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.orderCode" />
                    :
                  </span>
                  <span className="mr-2 orderInfo txtColorLightGreen">
                    {state.orderInfo ? state.orderInfo.orderCode : null}
                  </span>
                </div>
                <div className="d-flex justify-content-end">
                  <div
                    className={cls(
                      "ml-2",
                      state.orderInfo
                        ? parserOrderState(state.orderInfo.orderState).style
                        : ""
                    )}
                  >
                    {state.orderInfo.orderState && (
                      <FormattedMessage
                        id={parserOrderState(state.orderInfo.orderState).txt}
                      />
                    )}
                  </div>
                  <div
                    className={cls(
                      "ml-2",
                      state.orderInfo
                        ? checkIsOrderValid(state.orderInfo.isOrderValid).style
                        : ""
                    )}
                  >
                    {state.orderInfo.orderState && (
                      <FormattedMessage
                        id={checkIsOrderValid(state.orderInfo.isOrderValid).txt}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                {/* 顧客資訊 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    {state.orderInfo
                      ? state.orderInfo.customerInfo.branch
                      : null}
                  </span>
                  <span className="mr-2">
                    {state.orderInfo
                      ? state.orderInfo.customerInfo.adult
                      : null}
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.numberOfAdult" />
                  </span>
                  <span className="mr-2">
                    {state.orderInfo
                      ? state.orderInfo.customerInfo.child
                      : null}
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.numberOfChild" />
                  </span>
                  {/* {console.log("state",state)} */}
                  <span>{state.orderInfo ? state.countryName : null}</span>
                </div>
                {/* 排隊號碼 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.queueNumber" />
                    :
                  </span>
                  <span className="mr-2">
                    {state.orderInfo ? state.orderInfo.queueNumber : null}
                  </span>
                </div>
              </div>
              <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                {/* 點餐時間 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.time.orderTime" />
                    :
                  </span>
                  <span className="mr-2 txtColorBrown">
                    {state.orderInfo ? state.orderInfo.orderTime : null}
                  </span>
                </div>
                {/* 用餐時間 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.time.diningTime" />
                    :
                  </span>
                  <span className="mr-2 txtColorDarkBrown">
                    {state.orderInfo ? state.orderInfo.diningTime : null}
                  </span>
                </div>
              </div>
              <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                {/* 對單時間 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.time.checkedTime" />
                    :
                  </span>
                  <span className="mr-2 txtColorDarkGreen">
                    {state.orderInfo ? state.orderInfo.checkedTime : null}
                  </span>
                </div>
                {/* 對單人員 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffOrderDetail.orderInfo.staff" />
                    :
                  </span>
                  <span className="mr-2 txtColorDarkGreen">
                    {state.orderInfo ? state.orderInfo.staffInfo.group : null}
                  </span>
                  <span className="mr-2 txtColorDarkGreen">
                    {state.orderInfo
                      ? state.orderInfo.staffInfo.staffCode
                      : null}
                  </span>
                  <span className="mr-2 txtColorDarkGreen">
                    {state.orderInfo ? state.orderInfo.staffInfo.staff : null}
                  </span>
                </div>                
              </div>
              {state.orderInfo.TableNo?
              null:
              <div className="d-flex flex-column flex-sm-row align-items-center p-0">
                {/* 一線入席桌號 */}
                <div className="col col-sm-6 p-0 pt-2 pb-2">
                  <span className="mr-2">
                    <FormattedMessage id="pages.staffCheckOrder.orderInfo.lineInTable" />
                    :
                  </span>
                  <span className="mr-2">                    
                    {state.orderInfo.lineInTable ? 
                        (
                          <span>                
                          {(state.orderInfo.lineInTable.slice(-1)==="桌")?state.orderInfo.lineInTable.slice(0,-1):state.orderInfo.lineInTable}          
                          <FormattedMessage id="pages.staffOrderDetail.table" />
                          </span>)
                      : (<span className="txtColorRed">
                          <FormattedMessage id="pages.all.NoTableNumber" />
                        </span>)}
                  </span>
                </div>
              </div>
                }
              { //預點直接轉單顯示POS、ThirdParty錯誤訊息
                //$disabledCheckInButton?null:
                //<div className="d-flex justify-content-between align-items-center pt-2 pb-2 Pages__specification__title font-weight-bold">
                  //※訂單商品異常_請重新下單;1-005-883 迷你豆沙包規格餘量不足：2-G017-003 2個-熱
                //</div>
              }
            </div>
          </div>
          <div className="Pages__section d-flex flex-column col p-0">
            {/* 內用 */}
            <div className="Pages__section pt-3">
              {state.dineIn.length > 0 ? (
                state.dineIn.map((eachProduct, productIndex) => (
                  //<Tool_mealListShowOnly
                  //  key={productIndex}
                  //  deleteButton={false}
                  //  type="dineIn"
                  //  device={globalState.device}
                  //  data={eachProduct}
                  ///>
                  <div key={productIndex} className={
                    productIndex === state.dineIn.length - 1 ? "pt-1" : "border_under pt-1"
                  }>
                    <Tool_mealList
                      deleteButton={false}
                      modifyButton={false}
                      IsMultiLang={true}
                      type="dineIn"
                      device={globalState.device}
                      data={eachProduct}
                    />
                  </div>
                ))
              ) : (
                <div className="mt-3 text-center">
                  <FormattedMessage id="pages.staffOrderDetail.dineInNotExist" />
                </div>
              )}
            </div>
            {/* 外帶 */}
            <div className="Pages__section">
              {(() => {
                if (state.takeout.length <= 0) return null;
                return (
                  <>
                    <div className="Pages__space">
                      <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                        <FormattedMessage id="pages.staffOrderDetail.takeOrder" />
                      </div>
                    </div>
                    {state.takeout.map((eachProduct, productIndex) => (
                      //<Tool_mealListShowOnly
                      //  key={productIndex}
                      //  deleteButton={false}
                      //  type="takeout"
                      //  device={globalState.device}
                      //  data={eachProduct}
                      ///>
                      <div key={productIndex} className={
                        productIndex === state.takeout.length - 1 ? "pt-1" : "border_under pt-1"
                      }>
                        <Tool_mealList
                          deleteButton={false}
                          modifyButton={false}
                          IsMultiLang={true}
                          type="takeout"
                          device={globalState.device}
                          data={eachProduct}
                        />
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
            {/* 附加選項 */}
            {state.orderInfo.extraDataList.length>0 ?
            <>
              <div className="Pages__space">
              {/* 附加需求大分類標題之後有多個題目再加上去 */}
                <div className="Pages__specification__title Pages__space__item w-100 d-flex justify-content-center txtColorBrown pt-3 pb-3 mb-3 mt-3">
                  <FormattedMessage id="pages.staffCheckOrder.orderInfo.otherNeed" />
                </div>
              </div>
              <Tool_showExtraDataList  extraData={state.orderInfo.extraDataList} />
            </>:""}
            {/* 價格 */}
            <div className="Pages__section Pages__space mt-2 mt-sm-4 mb-2 mb-sm-4">
              <div className="Pages__space__item">
                {/* 合計 */}
                <div className="d-flex pr-3 pl-3">
                  <div className="col-4 col-sm-7"></div>
                  <div
                    className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
                    style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
                  >
                    <div className="d-flex justify-content-end align-items-center col-6 p-0">
                      <FormattedMessage id="pages.staffOrderDetail.sum.price" />
                    </div>
                    <div className="d-flex justify-content-end align-items-center col-6 p-0 orderInfo">
                      $
                      {formatNumber(
                        totalPrice().dineInSpecPrice +
                          totalPrice().dineInTotalPrice +
                          totalPrice().takeoutInSpecPrice +
                          totalPrice().takeoutInTotalPrice,
                        2
                      )}
                    </div>
                  </div>
                </div>
                {/* 服務費 */}
                <div className="d-flex pr-3 pl-3">
                  <div className="col-4 col-sm-7"></div>
                  <div
                    className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
                    style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
                  >
                    <div className="d-flex justify-content-end align-items-center col-6 p-0 text-right">
                      <FormattedMessage id="pages.staffOrderDetail.sum.tips" />
                      (10%)
                    </div>
                    <div
                      className="d-flex justify-content-end align-items-center col-6 p-0"
                      style={{ fontSize: "20px" }}
                    >
                      $
                      {formatNumber(
                        (totalPrice().dineInSpecPrice +
                          totalPrice().dineInTotalPrice) *
                          0.1,
                        2
                      )}
                    </div>
                  </div>
                </div>
                {/* 總計 */}
                <div className="d-flex pr-3 pl-3">
                  <div className="col-4 col-sm-7"></div>
                  <div
                    className="d-flex justify-content-center align-items-center col-8 col-sm-5 p-0 pt-3 pb-3"
                    style={{ borderBottom: "1px solid rgba(0,0,0,.1)" }}
                  >
                    <div className="d-flex justify-content-end align-items-center col-6 p-0">
                      <FormattedMessage id="pages.staffOrderDetail.sum.total" />
                    </div>
                    <div
                      className="d-flex justify-content-end align-items-center col-6 p-0 txtColorBrown"
                      style={{ fontSize: "20px" }}
                    >
                      $
                      {formatNumber(
                        (totalPrice().dineInSpecPrice +
                          totalPrice().dineInTotalPrice) *
                          1.1 +
                          totalPrice().takeoutInSpecPrice +
                          totalPrice().takeoutInTotalPrice,
                        2
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Pages__section">
              <div className="d-flex justify-content-center align-items-center p-3 txtColorRed text-justify">
                <FormattedMessage id="pages.staffOrderDetail.orderNotice" />
              </div>
            </div>
            {/* {$canReprint ? (
              <div className="d-flex justify-content-center align-items-center p-3">
                <CusCheckbox
                  checked={state.isCheckPrintDetail}
                  title={
                    <span>
                      <FormattedMessage id="pages.staffCheckOrder.step3.checkPrintDetail" />
                    </span>
                  }
                  onChange={() => {
                    setState(curr => {
                      return {
                        ...curr,
                        isCheckPrintDetail: !state.isCheckPrintDetail
                      }
                    })
                  }}
                />
              </div>
            ) : null} */}
            <div className="mt-4 mb-4 d-flex flex-column align-items-center">
              <div style={{ width: "500px" }} className="d-flex mb-2 col p-0">
                {/* 返回上頁 */}
                <CusButton.White
                  className="mr-3 p-3 col staff-order-detail-back"
                  children={
                    <FormattedMessage id="pages.staffOrderDetail.buttonBack" />
                  }
                  onClick={() => {
                    props.history.replace("/staffSearchOrder");
                    dispatchGlobal({
                      type: "UPDATE",
                      payload: [
                        {
                          key: "staffInfo",
                          val: {
                            ...globalState.staffInfo,
                            orderCode: null,
                          },
                        },
                      ],
                    });
                  }}
                />
                {$canReprint ? (
                  <CusButton.Red
                    className="ml-3 p-3 col"
                    children={
                      <FormattedMessage id="pages.staffOrderDetail.buttonReprint" />
                    }
                    onClick={async () => {
                      await apiReprintPreOrder(
                        state.orderInfo.posCode,
                        globalState.staffInfo.orderCode,
                        globalState.staffInfo.checkOrderBranch.branchCode
                      );
                    }}
                  />
                ) : null}
              </div>
              {!$canReprint ? (
                <div
                  className="Pages__notes pl-4 pr-4 p-sm-0 staff-order-detail-confirm"
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    if (!$disabledCheckInButton) {
                      const { orderCode } = globalState.staffInfo;
                      const langId = langStringToCode(globalState.langType);
                      const { staffInfo } = globalState;
                      let orderInfo = await apiOrderInfo(
                        orderCode,
                        langId,
                        staffInfo.checkOrderStaff.staffCode,
                        staffInfo.checkOrderBranch.branchCode,
                        moment(state.orderInfo.orderTime).format("YYYY/MM/DD")
                      );
                      if (orderInfo) {
                        dispatchGlobal({
                          type: "UPDATE",
                          payload: [
                            {
                              key: "langType",
                              val: langCodeToString(orderInfo.originOrderLanguageID),
                            },
                            {
                              key: "staffInfo",
                              val: {
                                ...globalState.staffInfo,
                                currentCheckOrderStep: "3",
                                prevPath: "/staffOrderDetail",
                                changeOrderLang: false,
                                checkOrderData: {
                                  state: orderInfo.status,
                                  dineIn: orderInfo.dineIn,
                                  takeout: orderInfo.takeout,
                                  numberOfAdult: orderInfo.adultsCount,
                                  numberOfChild: orderInfo.childCount,
                                  country: {
                                    countryId: orderInfo.countryID,
                                    countryName: orderInfo.countryName,
                                  },
                                  queueNumber: orderInfo.queueNumber,
                                  queueCode: orderInfo.queueCode,
                                  orderTime: orderInfo.createAt,
                                  branch: {
                                    branchCode: orderInfo.storeID,
                                    branchName: orderInfo.storeName,
                                  },
                                  remark: orderInfo.remark,
                                },
                              },
                            },
                          ],
                        });
                        props.history.push("/staffCheckOrder");
                        window.document.body.scrollTop = 0;
                      }
                    }
                  }}
                >
                  <div className="p-0 pt-2 pb-2 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-end">
                      <span className="ml-0 mt-1 mr-1 mb-1">
                        {globalState.staffInfo.checkOrderBranch.branchName}
                      </span>
                      <span className="m-1">
                        {globalState.staffInfo.checkOrderGroup.groupName}
                      </span>
                      <span className="m-1">
                        {globalState.staffInfo.checkOrderStaff.staffName}
                      </span>
                    </div>
                    <CusButton.Red
                      disabled={$disabledCheckInButton}
                      className="p-0 pt-2 pb-2 pl-5 pr-5"
                      children={
                        <FormattedMessage id="pages.staffOrderDetail.buttonConfirm" />
                      }
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default StaffOrderDetail;
